import React from 'react';
import Radio from './Radio';
import RadioItem from '@/types/radio-item';

interface Props {
  value?: RadioItem;
  onChange: (value: RadioItem, selected: boolean) => void;
  disabled: boolean;
  items: RadioItem[];
  ariaLabelledby?: string;
}

interface State {
  selected?: RadioItem;
}

class RadioGroup extends React.Component<Props, State> {
  static defaultProps = {
    items: [],
    onChange: () => {},
    disabled: false,
  };

  onRadioChange = (item: RadioItem, selected: boolean) => {
    this.props.onChange(item, selected);
  };

  resetValue = () => {
    this.onRadioChange(this.props.items[0], true);
  };

  render() {
    const { items, disabled, value, ariaLabelledby } = this.props;

    return (
      <div className="radio-group" role="radiogroup" aria-labelledby={ariaLabelledby}>
        {items.map((item, i) => (
          <Radio
            key={i}
            disabled={disabled}
            onChange={selected => this.onRadioChange(item, selected)}
            selected={value === item || (value && value.value === item.value)}
            label={item.label}
          />
        ))}
      </div>
    );
  }
}

export default RadioGroup;
